<div class="displayTable"> 
  <div class="login-logo">
    <img src="./assets/image/ancytree.logo.png" alt="">
  </div>
  <div class="displayTableCell">

    <div class="authBlock">
      <h3 i18n>Thank You for Registering</h3>

      <div class="formGroup" *ngIf="authService.userData as user">
        <p i18n  class="text-center">Thank you for your registration <strong>{{user.email}}</strong> and welcome to Ancytree. Now you just need to upload your GEDCOM file to start creating your family tree.</p>
        <p i18n  class="text-center">Happy creating!</p>
      </div>

      <!-- <div class="formGroup">
        <button i18n type="button" class="btn btnPrimary" (click)="authService.SendVerificationMail()">
          <i class="fas fa-redo-alt"></i>
          Resend Verification Email
        </button>
      </div> -->

    </div>

    <div class="redirectToLogin">
      <span i18n class="redirect" routerLink="/sign-in"> Sign in</span>
    </div>

  </div>
</div>
